import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Portfolio.css';

const PortfolioGrid = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch('/data/portfolio/projects.json')
      .then((r) => r.json())
      .then(setProjects)
      .catch((e) => console.error('Failed to load projects.json', e));
  }, []);

  return (
    <div className="portfolio">
      <div className="headline">
        <h2 className="title">Portfolio</h2>
      </div>
      <div className="portfolio-grid">
        {projects.map((p) => (
          <Link key={p.id} to={`/portfolio/${p.slug}`} className="portfolio-card" aria-label={p.title}>
            <img
              src={`/assets/projects/${p.id}/${p.cover || '01-cover.jpg'}`}
              alt={p.title || ''}
              className="cover"
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PortfolioGrid;
